import React from 'react';
import DataCollectionAnalysisTool from './DataCollectionAnalysisTool';
import { getDozorPlot } from '../../../../api/ispyb.js';
import { convertToFixed } from '../../../../helpers/NumericTransformationsHelper.js';
import PropTypes from 'prop-types';
import ResponsiveTable from '../../../Table/ResponsiveTable.js';
import ImageZoom from 'react-medium-image-zoom';
import _ from 'lodash';

export default class DataCollectionListDataCollectionGroupPanel extends React.Component {
    constructor(props) {
        super(props);       
        this.handleClick = this.handleClick.bind(this);
        this.handleOnSelect = this.handleOnSelect.bind(this);
     }

    handleClick(dataCollection){                    
        this.props.processDataCollection(dataCollection);
    }

    getHeaderStats(){
        return {
                    xs: { hidden: true },
                    sm: { hidden: true },
                    md: { width: '30px', textAlign: 'center' },
                    lg: { width: '60px', textAlign: 'center'}
                };
    };
       
    getColumn(text, dataField, formmater){
        return  {
            text: text,
            dataField: dataField,            
            formatExtraData: this,
            formatter: formmater           
        }
    };  

    getColumns() {     
        return [  
            { id : 'dataCollectionId', key : true},          
            this.getColumn('Prefix', 'imagePrefix'),
            this.getColumn('Run', 'dataCollectionNumber'),
            this.getColumn('# Images', 'numberOfImages'), 
            this.getColumn('Exp. Time', 'exposureTime'),
            this.getColumn('Res.(corner)', 'resolution', function(cell, row, rowIndex, extraData) { return  convertToFixed(row.resolution,1) + " Å (" + convertToFixed(row.resolutionAtCorner, 1) + "Å)"; }),
            this.getColumn('Wavelength', 'wavelength'),
            this.getColumn('Transmission', 'transmission', function(cell, row, rowIndex, extraData) { return row.transmission + " %"} ),
            this.getColumn('Folder', 'folder', function(cell, row, rowIndex, extraData) { return "-"} ),
            this.getColumn('Time', 'startTime'),
            this.getColumn('Status', 'runStatus'),
            this.getColumn('Indicators', 'Indicators', function(cell, row, rowIndex, extraData){ return <ImageZoom image={{ style : {width:'40px'},  src :  getDozorPlot(extraData.props.user, extraData.props.proposal, row.dataCollectionId) }} /> }),
            this.getColumn('View Results', 'View Result', function(cell, row, rowIndex, extraData) { return "-"} ),            
            this.getColumn('Phasing', 'hasPhasing'),
            this.getColumn('Comments', 'comments'),
            this.getColumn('', '', function(cell, row, rowIndex, extraData) { 
                return <DataCollectionAnalysisTool 
                jobs={extraData.props.jobs}
                configuration={extraData.props.configuration}
                datacollection={row} >

                </DataCollectionAnalysisTool>                                                        
        })];
    }

    
    handleOnSelect = (row, isSelect) => {        
        if (isSelect) {
            
            this.props.selectDataCollection(row);
        }
        else {
            this.props.unselectDataCollection(row);
        }
        
        return true;
    }
    
    render() {      
        const selectRow = {
            mode: 'checkbox',
            clickToSelect: false,
            selected: _.map(this.props.selectedDataCollections, "dataCollectionId"),         
            onSelect: this.handleOnSelect
        };          
        
        return <ResponsiveTable  
                keyField="dataCollectionId"
                selectRow={selectRow} 
                pageOptions={{sizePerPage:100}} 
                search={false}  
                data = {this.props.dataCollections}  
                columns = {this.getColumns()}/>;        
    }
}

DataCollectionListDataCollectionGroupPanel.propTypes = {
    dataCollections : PropTypes.array,
    selectedDataCollections : PropTypes.array,
    processDataCollection : PropTypes.func,
    fetching : PropTypes.bool

}


// WEBPACK FOOTER //
// ./src/components/Mx/DataCollectionGroup/DataCollectionListDataCollectionGroup/DataCollectionListDataCollectionGroupPanel.js